export const iconFontAwesomeMediaplaybackRotate = (
	<i className="fa-solid fa-rotate"></i>
);
